import { render, staticRenderFns } from "./uploadMaterialModal.vue?vue&type=template&id=6f337aa0&scoped=true"
import script from "./uploadMaterialModal.vue?vue&type=script&lang=js"
export * from "./uploadMaterialModal.vue?vue&type=script&lang=js"
import style0 from "./uploadMaterialModal.vue?vue&type=style&index=0&id=6f337aa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f337aa0",
  null
  
)

export default component.exports